// extracted by mini-css-extract-plugin
module.exports = {"root":"DownloadApp_root___jyAa"};